import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

interface ModalsState {
  modals: ModalTypes[]
  current?: ModalTypes
}

const initialState: ModalsState = {
  current: undefined,
  modals: [],
}

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    resetModals() {
      return initialState
    },
    openModal(state, action: PayloadAction<ModalTypes>) {
      if (!state.modals.includes(action.payload)) {
        state.modals.push(action.payload)
      }
    },
    closeModal(state, action: PayloadAction<ModalTypes>) {
      state.modals = state.modals.filter((modal) => modal !== action.payload)
    },
  },
})

export const { resetModals, openModal, closeModal } = modalsSlice.actions

export default modalsSlice.reducer
